module.exports = __webpack_public_path__ + "static/media/cq_editor_lista_puntata b.3b4c55c5.svg";